import React from "react";

export default function ProctorEyeSvg(Props) {
  return Props.type === 2 ? (
    <svg
      width="32"
      height="33"
      fill="none"
      viewBox="0 0 32 33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          fill="#FF2D00"
          d="M18.6667 4.1665C21.2091 4.1665 23.0153 4.16862 24.3856 4.35285C25.7269 4.53321 26.4999 4.87142 27.0641 5.4357C27.7136 6.08522 27.9964 6.58872 28.1529 7.48629C28.3295 8.49797 28.3333 9.94106 28.3333 12.4998C28.3333 13.0521 28.7811 13.4998 29.3333 13.4998C29.8856 13.4998 30.3333 13.0521 30.3333 12.4998V12.3714C30.3335 9.9725 30.3335 8.34745 30.1232 7.14249C29.8893 5.80204 29.3909 4.93408 28.4784 4.02149C27.4805 3.02368 26.2153 2.58085 24.652 2.37069C23.1331 2.16646 21.1923 2.16648 18.7419 2.1665H18.6667C18.1144 2.1665 17.6667 2.61422 17.6667 3.1665C17.6667 3.71878 18.1144 4.1665 18.6667 4.1665Z"
        />
        <path
          fill="#FF2D00"
          d="M2.66668 19.5C3.21896 19.5 3.66668 19.9477 3.66668 20.5C3.66668 23.0588 3.67052 24.5019 3.84705 25.5136C4.00367 26.4111 4.28636 26.9147 4.93588 27.5641C5.50016 28.1284 6.27301 28.4667 7.61447 28.6469C8.98469 28.8312 10.7909 28.8333 13.3333 28.8333C13.8856 28.8333 14.3333 29.2811 14.3333 29.8333C14.3333 30.3856 13.8856 30.8333 13.3333 30.8333H13.2581C10.8078 30.8333 8.86693 30.8333 7.34797 30.6292C5.78475 30.4189 4.51948 29.9761 3.52167 28.9784C2.60908 28.0657 2.11072 27.1977 1.87683 25.8573C1.66656 24.6524 1.6666 23.0273 1.66667 20.6285L1.66668 20.5C1.66668 19.9477 2.11439 19.5 2.66668 19.5Z"
        />
        <path
          fill="#FF2D00"
          d="M29.3333 19.5C29.8856 19.5 30.3333 19.9477 30.3333 20.5V20.6284C30.3335 23.0273 30.3335 24.6524 30.1232 25.8573C29.8893 27.1977 29.3909 28.0657 28.4784 28.9784C27.4805 29.9761 26.2153 30.4189 24.652 30.6292C23.1331 30.8333 21.1923 30.8333 18.7419 30.8333H18.6667C18.1144 30.8333 17.6667 30.3856 17.6667 29.8333C17.6667 29.2811 18.1144 28.8333 18.6667 28.8333C21.2091 28.8333 23.0153 28.8312 24.3856 28.6469C25.7269 28.4667 26.4999 28.1284 27.0641 27.5641C27.7136 26.9147 27.9964 26.4111 28.1529 25.5136C28.3295 24.5019 28.3333 23.0588 28.3333 20.5C28.3333 19.9477 28.7811 19.5 29.3333 19.5Z"
        />
        <path
          fill="#FF2D00"
          d="M13.2581 2.1665H13.3333C13.8856 2.1665 14.3333 2.61422 14.3333 3.1665C14.3333 3.71878 13.8856 4.1665 13.3333 4.1665C10.7909 4.1665 8.98469 4.16862 7.61447 4.35285C6.27301 4.53321 5.50016 4.87142 4.93588 5.4357C4.28636 6.08522 4.00367 6.58872 3.84705 7.48629C3.67052 8.49797 3.66668 9.94106 3.66668 12.4998C3.66668 13.0521 3.21896 13.4998 2.66668 13.4998C2.11439 13.4998 1.66668 13.0521 1.66668 12.4998L1.66667 12.3714C1.6666 9.97254 1.66656 8.34744 1.87683 7.14249C2.11072 5.80204 2.60908 4.93408 3.52167 4.02149C4.51948 3.02368 5.78475 2.58085 7.34797 2.37069C8.86692 2.16646 10.8078 2.16648 13.2581 2.1665Z"
        />
      </g>
      <path
        fill="#370B67"
        d="M16 14.8335C15.0795 14.8335 14.3333 15.5796 14.3333 16.5002C14.3333 17.4207 15.0795 18.1668 16 18.1668C16.9205 18.1668 17.6667 17.4207 17.6667 16.5002C17.6667 15.5796 16.9205 14.8335 16 14.8335Z"
      />
      <path
        fill="#370B67"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.85657 19.2466C7.06329 18.3264 6.66667 17.8663 6.66667 16.5002C6.66667 15.134 7.06331 14.6739 7.85656 13.7538C9.44049 11.9165 12.0969 9.8335 16 9.8335C19.9031 9.8335 22.5595 11.9165 24.1435 13.7538C24.9367 14.6739 25.3333 15.134 25.3333 16.5002C25.3333 17.8663 24.9367 18.3264 24.1435 19.2466C22.5595 21.0839 19.9031 23.1668 16 23.1668C12.0969 23.1668 9.44051 21.0839 7.85657 19.2466ZM12.3333 16.5002C12.3333 14.4751 13.9749 12.8335 16 12.8335C18.0251 12.8335 19.6667 14.4751 19.6667 16.5002C19.6667 18.5252 18.0251 20.1668 16 20.1668C13.9749 20.1668 12.3333 18.5252 12.3333 16.5002Z"
      />
    </svg>
  ) : (
    <svg
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      onClick={Props.onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2786_14069)">
        <rect x="2" y="1" width="36" height="36" rx="8" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          rx="7.5"
          width="35"
          height="35"
          stroke="#D0D5DD"
        />
        <g clip-path="url(#clip0_2786_14069)">
          <path
            stroke="#344054"
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.834 18.9997C10.834 18.9997 14.1673 12.333 20.0007 12.333C25.834 12.333 29.1673 18.9997 29.1673 18.9997C29.1673 18.9997 25.834 25.6663 20.0007 25.6663C14.1673 25.6663 10.834 18.9997 10.834 18.9997Z"
          />
          <path
            stroke="#344054"
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M20.0007 21.4997C21.3814 21.4997 22.5006 20.3804 22.5006 18.9997C22.5006 17.619 21.3814 16.4997 20.0007 16.4997C18.6199 16.4997 17.5007 17.619 17.5007 18.9997C17.5007 20.3804 18.6199 21.4997 20.0007 21.4997Z"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0"
          y="0"
          width="40"
          height="40"
          id="filter0_d_2786_14069"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2786_14069"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect1_dropShadow_2786_14069"
          />
        </filter>
        <clipPath id="clip0_2786_14069">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(10 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
